import React, { Component } from "react";

class ActList extends Component {
    render() {
        return <div className="act-list" style={{marginBottom: `100px`,}}> {this.props.children} </div>;
    }
}

export default ActList;
